import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GlobalOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { observer } from "mobx-react";
import { COLOR_ERROR_SOFT } from "../../../../../../style/antdTheme.js";
import { formatLocaleDateTime } from "../../../../../../utils/formatLocaleDate.js";
import { __, _i } from "../../../../../../utils/i18n.js";
import { MATOMO_MASK } from "../../../../../../utils/matomoMask.js";
const LicenseActivationRow = observer(({ activation, isReadOnly, onRevoke })=>{
    const isProduction = activation.data.type === "production";
    return /*#__PURE__*/ _jsxs("div", {
        className: "rc-account-v2-subscription-card__activation-row",
        children: [
            /*#__PURE__*/ _jsx(GlobalOutlined, {
                className: "rc-account-v2-subscription-card__activation-icon",
                "aria-hidden": true
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "rc-account-v2-subscription-card__activation-text",
                children: [
                    /*#__PURE__*/ _jsx("code", {
                        className: "rc-account-v2-subscription-card__activation-host",
                        ...MATOMO_MASK,
                        children: activation.host
                    }),
                    /*#__PURE__*/ _jsxs("span", {
                        className: "rc-account-v2-subscription-card__activation-meta",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: `rc-account-v2-subscription-card__activation-type rc-account-v2-subscription-card__activation-type--${isProduction ? "production" : "development"}`,
                                children: isProduction ? __("Production") : __("Development")
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "rc-account-v2-subscription-card__activation-version",
                                children: __("Plugin version %s", activation.pluginVersion)
                            }),
                            activation.isConnectionLost && /*#__PURE__*/ _jsx(Tooltip, {
                                title: _i(__("The license server last had contact with this installation on {{span}}%s{{/span}}. Maybe you deleted it in the meantime? If so, you can revoke the activation and use the license on another website.", formatLocaleDateTime(activation.lastSeen, "")), {
                                    span: /*#__PURE__*/ _jsx("span", {
                                        ...MATOMO_MASK
                                    })
                                }),
                                children: /*#__PURE__*/ _jsxs("span", {
                                    className: "rc-account-v2-subscription-card__activation-warn",
                                    children: [
                                        /*#__PURE__*/ _jsx(QuestionCircleOutlined, {
                                            "aria-hidden": true
                                        }),
                                        __("Connection lost")
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Tooltip, {
                title: isReadOnly ? __("Update your payment method to manage activations again.") : "",
                children: /*#__PURE__*/ _jsx(Button, {
                    type: "text",
                    size: "small",
                    disabled: isReadOnly,
                    onClick: ()=>onRevoke(activation),
                    style: isReadOnly ? undefined : {
                        color: COLOR_ERROR_SOFT
                    },
                    className: "rc-account-v2-subscription-card__activation-revoke",
                    children: __("Revoke")
                })
            })
        ]
    });
});
export { LicenseActivationRow };
